export default {
  drawAreaNewEstate(currentMap) {
    let bkData = JSON.parse(sessionStorage.getItem("xfsbk_data"));
    let oldEstate = JSON.parse(sessionStorage.getItem("xfsbk_oldestate"));
    let dots = bkData.center.split("|");
    currentMap.setCenter(dots);
    dots = bkData.dots.split("-").map((x) => {
      return x.split("|");
    });
    let polygon = new AMap.Polygon({
      path: dots,
      fillOpacity: 0,
      strokeWeight: 5,
      strokeOpacity: 1,
      strokeColor: "#333333",
    });
    currentMap.add(polygon);
    currentMap.setFitView([polygon], false, [0, 0, 0, 0]);
    if (importPt && importPt.newEstateList) {
      for (let index = 0; index < importPt.newEstateList.length; index++) {
        const element = importPt.newEstateList[index];
        let markerContent = `
                <div class="pt-tag" style="background-color:#ff000e">
                  <div>
                  ${element.location_name}
                </div>
                `;
        if (element.priceArr) {
          for (let k = 0; k < element.priceArr.length; k++) {
            markerContent += `<div>${element.priceArr[k]}</div>`;
          }
        }
        if (element.open_date) {
          markerContent += `<div>预计开盘：${element.open_date}</div>`;
        }
        markerContent += `</div>`;
        let marker = new AMap.Marker({
          position: element.lnglat.split("-")[0].split("|"),
          content: markerContent,
          offset: new AMap.Pixel(0, 0),
          draggable: true,
          zIndex: 120,
        });
        marker.setMap(currentMap);
      }
    }
    if (oldEstate && oldEstate.length) {
      for (let k = 0; k < oldEstate.length; k++) {
        const element = oldEstate[k];
        let markerContent = `
                <div class="pt-tag" style="background-color:#002af6">
                  <div>
                  ${element.location_name}
                </div>
                `;
        if (element.avg_deal_price != 0) {
          markerContent += `<div>网签 ${parseFloat(
            element.avg_deal_price / 10000
          ).toFixed(1)}万元/m²</div>`;
        }
        if (element.avg_source_price != 0) {
          markerContent += `<div>挂牌 ${parseFloat(
            element.avg_source_price / 10000
          ).toFixed(1)}万元/m²</div>`;
        }
        markerContent += `</div>`;
        let marker = new AMap.Marker({
          position: element.lnglat.split("-")[0].split("|"),
          content: markerContent,
          offset: new AMap.Pixel(0, 0),
          draggable: true,
          zIndex: 120,
        });
        marker.setMap(currentMap);
      }
    }
    currentMap.setZoom(14);
  },

  // 画楼盘
  drawNewReals(currentMap) {
    let that = this;
    that.$axios
      .get(that.$url_prefix + "getNewRealsDrawMap", {
        params: {
          type: that.type,
        },
      })
      .then(function (res) {
        console.log("所有新房", res);
        let list = res.data.data;
        let mapData = {};
        for (let i = 0; i < list.length; i++) {
          let loc = list[i];
          let markerContent = "";
          let piece = loc.piece;
          let judge = "#edd716"; // 不是地铁盘
          if (loc.sub == 1) {
            judge = "#ff8f8f"; // 地铁盘
          } else if (loc.sub == 2) {
            judge = "#bbd0f8"; // 四期地铁盘
          }
          let expect = "";
          if (that.type == "公示登记") {
            judge = "#b2d0e6";
            if (loc.state == "正在公示" || loc.state == "已拿预售证") {
              judge = "#ff4769";
            } else if (loc.state == "正在登记") {
              judge = "#ff4769";
            } else if (loc.ex) {
              judge = "#a8e98e";
            }
          } else {
            if (loc.ex) {
              expect = `<div class="expect">${loc.ex}</div>`;
            }
          }

          if (!that.currentArea.includes("全城")) {
            if (loc.district !== that.currentArea) {
              continue;
            }
          }
          piece.forEach((x) => {
            if (x.price1) {
              x.price = x.price1;
            }
          });
          piece.sort((a, b) => {
            return a.price - b.price;
          });
          let priceLen = piece.length;
          // if (loc.limit_buy == 1) {
          //   judge = '#ff8a3b';
          //   console.log('1')
          // } else if (loc.limit_buy == 2) {
          //   judge = '#b4ff00';
          //   console.log('2')
          // } else if (loc.limit_buy == 3) {
          //   judge = '#ffcc00';
          //   console.log('3')
          // }
          if (priceLen === 0) {
            markerContent = `
            <div class="newEstate">
              <div class="realPrice" style="background-color:${judge}">
                <div>${loc.real_estate_name}</div>
              </div>
              ${expect}
            </div>
            `;
          } else if (priceLen === 1) {
            markerContent = `
            <div class="newEstate">
              <div class="realPrice" style="background-color:${judge}">
                <div>${loc.real_estate_name}</div>
                <div class="realPrice-c">${piece[0].type}${piece[0].price}</div>
              </div>
              ${expect}
            </div>
            `;
          } else if (priceLen === 2) {
            markerContent = `
            <div class="newEstate">
              <div class="realPrice" style="background-color:${judge}">
                <div>${loc.real_estate_name}</div>
                <div class="realPrice-c">${piece[0].type}${piece[0].price}</div>
                <div class="realPrice-c">${piece[1].type}${piece[1].price}</div>
              </div>
              ${expect}
            </div>
            `;
          } else if (priceLen > 2) {
            markerContent = `
            <div class="newEstate">
              <div class="realPrice" style="background-color:${judge}">
                <div>${loc.real_estate_name}</div>
                <div class="realPrice-c">${piece[0].type}${piece[0].price}</div>
                <div class="realPrice-c">${piece[1].type}${piece[1].price}</div>
                <div class="realPrice-c">${piece[2].type}${piece[2].price}</div>
              </div>
              ${expect}
            </div>
            `;
          }

          let realPos = loc.lnglat.split("|");
          let position = realPos;
          if (loc.move) {
            position = loc.move.split("|");
            mapData[loc.id] = {
              marker: realPos,
              line: [realPos, position],
            };
          }

          let nameLen = loc.real_estate_name.length;
          if (nameLen <= 6 && priceLen > 0) {
            nameLen = 6.5;
          }
          let offsetX = -nameLen * 10;
          let offsetY = -(priceLen + 1) * 15;

          let marker = new AMap.Marker({
            real_id: loc.id,
            position: position,
            content: markerContent,
            offset: new AMap.Pixel(offsetX, offsetY),
            draggable: true,
          });
          marker.on("dragstart", (e) => {
            console.log("开始移动", e.target.w.real_id);
            let real_id = e.target.w.real_id;
            if (!that.realMarkers[real_id]) {
              let dot = loc.lnglat.split("|");
              let temp = JSON.parse(JSON.stringify(that.realMarkers));
              temp[real_id] = {
                marker: dot,
                line: [dot, dot],
              };
              that.realMarkers = temp;
            }
          });
          marker.on("dragging", (e) => {
            let real_id = e.target.w.real_id;
            let temp = JSON.parse(JSON.stringify(that.realMarkers));
            temp[real_id].line[1] = [e.lnglat.lng, e.lnglat.lat];
            that.realMarkers = temp;
          });
          marker.on("dragend", (e) => {
            console.log("移动结束", that.realMarkers);
            let real_id = e.target.w.real_id;
            let temp = JSON.parse(JSON.stringify(that.realMarkers));
            let pos = e.target.getPosition();
            temp[real_id].line[1] = [pos.lng, pos.lat];
            that.realMarkers = temp;
            that.saveNewRealMarkers(real_id);
          });
          marker.on("rightclick", (e) => {
            console.log("右击", e);
            let real_id = e.target.w.real_id;
            if (that.realMarkers[real_id]) {
              let temp = JSON.parse(JSON.stringify(that.realMarkers));
              e.target.setPosition(temp[real_id].marker);
              delete temp[real_id];
              that.realMarkers = temp;
              that.saveNewRealMarkers(real_id);
            }
          });

          marker.setMap(currentMap);
        }
        that.realMarkers = mapData;
      })
      .catch(function (res) {
        console.log("所有新房失败", res);
      });
  },

  drawNewReals2(currentMap) {
    let that = this;
    that.$axios
      .get(that.$url_prefix + "getNewRealsDrawMap", {
        params: {
          type: that.type,
        },
      })
      .then(function (res) {
        console.log("所有新房", res);
        let list = res.data.data;
        let mapData = {};
        for (let i = 0; i < list.length; i++) {
          let loc = list[i];
          let piece = loc.piece;

          piece.forEach((x) => {
            if (x.price1) {
              x.price = x.price1;
            }
          });
          piece.sort((a, b) => {
            return a.price - b.price;
          });
          piece = piece.slice(0, 3);
          const priceLen = piece.length;
          let priceContent = [];
          piece.forEach((y) => {
            priceContent.push(
              `<div class="realPrice-c">${y.type}${y.price}</div>`
            );
          });

          // 处理楼盘名换行
          let nlimit = 14;
          let nameContent = [];
          if (loc.real_estate_name.length > nlimit) {
            nameContent.push(
              `<div>${loc.real_estate_name.slice(0, nlimit - 3)}</div>`
            );
            nameContent.push(
              `<div>${loc.real_estate_name.slice(nlimit - 3)}</div>`
            );
          } else {
            nameContent.push(`<div>${loc.real_estate_name}</div>`);
          }

          let markerContent = `
            <div class="newEstate2">
              ${nameContent.join("\n")}
              ${priceContent.join("\n")}
            </div>
            `;

          let realPos = loc.lnglat.split("|");
          let position = realPos;
          if (loc.move) {
            position = loc.move.split("|");
            mapData[loc.id] = {
              marker: realPos,
              line: [realPos, position],
            };
          }

          let nameLen = loc.real_estate_name.length;
          if (nameLen <= 6 && priceLen > 0) {
            nameLen = 6.5;
          }
          let offsetX = -nameLen * 10;
          let offsetY = -(priceLen + 1) * 15;

          let marker = new AMap.Marker({
            real_id: loc.id,
            position: position,
            content: markerContent,
            offset: new AMap.Pixel(offsetX, offsetY),
            draggable: true,
          });
          marker.on("dragstart", (e) => {
            console.log("开始移动", e.target.w.real_id);
            let real_id = e.target.w.real_id;
            if (!that.realMarkers[real_id]) {
              let dot = loc.lnglat.split("|");
              let temp = JSON.parse(JSON.stringify(that.realMarkers));
              temp[real_id] = {
                marker: dot,
                line: [dot, dot],
              };
              that.realMarkers = temp;
            }
          });
          marker.on("dragging", (e) => {
            let real_id = e.target.w.real_id;
            let temp = JSON.parse(JSON.stringify(that.realMarkers));
            temp[real_id].line[1] = [e.lnglat.lng, e.lnglat.lat];
            that.realMarkers = temp;
          });
          marker.on("dragend", (e) => {
            console.log("移动结束", that.realMarkers);
            let real_id = e.target.w.real_id;
            let temp = JSON.parse(JSON.stringify(that.realMarkers));
            let pos = e.target.getPosition();
            temp[real_id].line[1] = [pos.lng, pos.lat];
            that.realMarkers = temp;
            that.saveNewRealMarkers(real_id);
          });
          marker.on("rightclick", (e) => {
            console.log("右击", e);
            let real_id = e.target.w.real_id;
            if (that.realMarkers[real_id]) {
              let temp = JSON.parse(JSON.stringify(that.realMarkers));
              e.target.setPosition(temp[real_id].marker);
              delete temp[real_id];
              that.realMarkers = temp;
              that.saveNewRealMarkers(real_id);
            }
          });

          marker.setMap(currentMap);
        }
        that.realMarkers = mapData;
      })
      .catch(function (res) {
        console.log("所有新房失败", res);
      });
  },

  drawOldReals(currentMap) {
    let that = this;
    that.$axios
      .get(that.$url_prefix + "getOldRealsDrawMap")
      .then(function (res) {
        let list = res.data.data.filter((x) => {
          if (
            !that.currentArea.includes("全城") &&
            x.area !== that.currentArea
          ) {
            return false;
          }
          return true;
        });
        for (let i = 0; i < list.length; i++) {
          let loc = list[i];
          let markerContent = "";
          let minPrice = loc.price;

          markerContent = `
          <div class="oldPrice1">
            <div>${
              loc.real_estate_name + Math.round(minPrice / 1000) / 10 + "万"
            }</div>
          </div>
          `;
          let position = loc.lnglat.split("-")[0].split("|");

          var marker = new AMap.Marker({
            zIndex: 120,
            real_id: loc.id,
            position: position,
            content: markerContent,
            offset: new AMap.Pixel(-20, -15),
            draggable: true,
          });
          marker.setMap(currentMap);
        }
      })
      .catch(function (res) {
        console.log("所有二手房失败", res);
      });
  },

  // 画学区
  drawSchoolArea(currentMap) {
    let that = this;
    that.$axios.get(that.$url_prefix + "getSchoolArea").then((res) => {
      let list = res.data.data;
      console.log("学区", list);
      for (let i = 0; i < list.length; i++) {
        let loc = list[i];
        // 板块区域
        let dotsList = [];
        if (loc.dots.includes("-")) {
          dotsList = [loc.dots.split("-")];
        } else {
          dotsList = JSON.parse(loc.dots);
        }
        for (let k = 0; k < dotsList.length; k++) {
          if (dotsList[k].length > 0) {
            let dots = dotsList[k].map((x) => x.split("|"));
            let polygon = new AMap.Polygon({
              path: dots,
              fillOpacity: 0.2,
              fillColor: "#000000",
              strokeWeight: 1,
              strokeOpacity: 1,
              strokeColor: "#383838",
            });
            currentMap.add(polygon);
          }
        }

        let markerContent = `
            <div class="landDeal">
              <div>${loc.location_name}</div>
            </div>
            `;

        let marker = new AMap.Marker({
          location_id: loc.id,
          position: loc.lnglat.split("|"),
          content: markerContent,
          offset: new AMap.Pixel(-20, -15),
          draggable: true,
        });
        marker.setMap(currentMap);
      }
    });
  },
};



// WEBPACK FOOTER //
// ./src/page/makeLocationImage/methods/bindEstate.js